<template>
  <div class="code-container">
    <button class="copy-btn" @click="copyCode">
      {{ copied ? '¡Copiado!' : 'Copiar' }}
    </button>
    
    <pre><code ref="codeBlock" :class="'language-' + language">{{ code }}</code></pre>
  </div>
</template>

<script>
import hljs from 'highlight.js';
export default {
  name: 'CodeBlock',
    props: {
			code: {
				type: String,
				required: true
			},
			language: {
				type: String,
				default: 'json'
			}
    },
    data() {
			return {
				copied: false
			}
    },
		mounted() {
    	this.highlightCode();
  	},
    methods: {
			highlightCode() {
				this.$nextTick(() => {
					if (this.$refs.codeBlock) {
						hljs.highlightElement(this.$refs.codeBlock);
					}
				});
   	 },
		async copyCode() {
			try {
				await navigator.clipboard.writeText(this.code);
				this.copied = true; 
				setTimeout(() => {
					this.copied = false;
				}, 2000);
			} catch (err) {
				console.error('Error al copiar el código: ', err);
			}
		}
	},
	watch: {
    code() {
      this.highlightCode();
    }
  },
};


</script>

<style scoped>
/* Estructura base inspirada en editores oscuros (ej. VS Code) */
.code-container {
  position: relative;
  background-color: #282c34; /* Fondo oscuro */
  border-radius: 8px;
  padding: 24px 16px 16px;
  margin: 16px 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.copy-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #3e4451;
  color: #abb2bf;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  transition: all 0.2s ease-in-out;
}

.copy-btn:hover {
  background-color: #5c6370;
  color: #ffffff;
}

pre {
  margin: 0;
  overflow-x: auto; /* Permite scroll horizontal si el código es muy largo */
}

/* Forzar el color base del texto por si los corchetes no tienen clase */
code {
  font-family: 'Fira Code', 'Courier New', Courier, monospace;
  color: #abb2bf !important; /* Gris claro para texto general y corchetes */
  font-size: 14px;
  line-height: 1.5;
}

/* Forzar el color de la puntuación en Highlight.js */
:deep(.hljs-punctuation),
:deep(.hljs-brace) {
  color: #abb2bf !important; /* Gris claro */
  font-weight: bold;
}

/* Opcional: Darle un color distinto a las llaves/corchetes si lo prefieres */
/*
:deep(.hljs-punctuation) {
  color: #56b6c2 !important; 
}
*/
</style>